import { BreadcrumbItem, Breadcrumbs } from '@components/display/breadcrumbs';
import { usePublicLayoutOptions } from '@components/layout/public';
import { APP_PREFIX_PATH } from '@constants/common';
import { OnlineTrainingContext } from '@onlineTraining/contexts';
import { OnlineTrainingDetail } from '@onlineTraining/routes/public/OnlineTrainingDetail';
import { OnlineTrainingList } from '@onlineTraining/routes/public/OnlineTrainingList';
import { NotFound } from '@routes/NotFound';
import { ReactNode, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Route, Routes } from 'react-router-dom';

const OnlineTrainingViews = () => {
    const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([
        {
            label: <FormattedMessage id="onlineTraining.title" defaultMessage="Online training" />,
            to: APP_PREFIX_PATH + '/online-training',
        },
    ]);
    const [extraButton, setExtraButton] = useState<ReactNode>(null);
    const extraToolbar = useMemo(
        () => <Breadcrumbs path={breadcrumbs} extraButton={extraButton} />,
        [breadcrumbs, extraButton]
    );
    usePublicLayoutOptions({ extraToolbar });

    return (
        <OnlineTrainingContext.Provider value={{ setBreadcrumbs, setExtraButton }}>
            <Routes>
                <Route path="/" element={<OnlineTrainingList />} />
                <Route path="/:id" element={<OnlineTrainingDetail />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </OnlineTrainingContext.Provider>
    );
};

export { OnlineTrainingViews };
